import React from 'react'

import { Icon } from '../Icon'

type Props = {
    className?: string
    left?: React.ReactNode
    right?: React.ReactNode
    multiSelect?: boolean
    isSelected?: boolean
    isDisabled?: boolean
    onSelect: () => void
}

export const CalendarSelectCard = ({
    className = '',
    left,
    right,
    multiSelect = true,
    isSelected = false,
    isDisabled = false,
    onSelect,
}: Props) => {
    return (
        <div
            className={`flex items-center rounded-lg border-[1px] border-gray-300 p-4 hover:bg-gray-100 ${isSelected ? 'border-primary-700 border-[1px]' : ''} ${isDisabled ? 'cursor-auto opacity-35' : 'hover:cursor-pointer'} ${className}`}
            onClick={() => (!isDisabled ? onSelect() : null)}
        >
            {left}

            <div className="ml-auto flex">
                {right}

                {!right && (
                    <div
                        className={`flex size-6 items-center justify-center border-[1px] border-gray-300 bg-white ${multiSelect ? 'rounded-[4px] bg-white' : 'rounded-full'}`}
                    >
                        {isSelected && (
                            <>
                                {multiSelect && <Icon icon="checkmark.large" />}
                                {!multiSelect && (
                                    <div className="bg-primary-700 flex size-full items-center justify-center rounded-full border-none">
                                        <div className="size-2 rounded-full bg-white"></div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
